import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { BoardScene } from "../BoardScene";
import { BoardManager } from "../BoardManager";
import { AudioManager } from "../../../AudioManager";

export class DiceContainer extends Phaser.GameObjects.Container {

    private playerDice: Phaser.GameObjects.Sprite;
    private botDice: Phaser.GameObjects.Sprite;

    constructor(scene: Phaser.Scene) {

        super(scene);

        let posX = GameConstants.GAME_WIDTH / 2 + 335 * GameVars.scaleX;

        this.botDice = new Phaser.GameObjects.Sprite(this.scene, posX + (GameConstants.GAME_WIDTH - posX) / 2, 340, "texture_atlas_3", "dice_blue_3_01");
        this.botDice.scaleX = GameVars.scaleX;
        BoardScene.currentInstance.add.existing(this.botDice);
        this.botDice.visible = false;
        this.add(this.botDice);

        this.botDice.on("animationcomplete", this.onAnimationComplete, this);

        this.playerDice = new Phaser.GameObjects.Sprite(this.scene, posX + (GameConstants.GAME_WIDTH - posX) / 2, 430, "texture_atlas_3", "dice_pink_3_01");
        this.playerDice.scaleX = GameVars.scaleX;
        BoardScene.currentInstance.add.existing(this.playerDice);
        this.playerDice.visible = false;
        this.add(this.playerDice);

        this.playerDice.on("animationcomplete", this.onAnimationComplete, this);
    }

    public startMatch(): void {

        if (GameVars.mode === GameConstants.VS_PLAYER) {
            this.botDice.scaleY = -1;
            this.botDice.y = 430;
            
            let posX = GameConstants.GAME_WIDTH / 2 - 335 * GameVars.scaleX;
            let posX2 = GameConstants.GAME_WIDTH / 2 + 335 * GameVars.scaleX;
            this.playerDice.x = posX - (GameConstants.GAME_WIDTH - posX2) / 2;
        }
    }

    public roll(i: number): void {

        if (GameVars.currentTurn === GameConstants.PLAYER) {
  
            this.scene.tweens.add({
                targets: this.botDice,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300,
                onComplete: function(): void {
                    this.botDice.visible = false;
                },
                onCompleteScope: this
            });

            this.playerDice.visible = true;
            this.playerDice.alpha = 0;

            this.scene.tweens.add({
                targets: this.playerDice,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300
            });

            this.playerDice.play("dice_pink_" + i);

        } else {

            this.scene.tweens.add({
                targets: this.playerDice,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300,
                onComplete: function(): void {
                    this.playerDice.visible = false;
                },
                onCompleteScope: this
            });

            this.botDice.visible = true;
            this.botDice.alpha = 0;

            this.scene.tweens.add({
                targets: this.botDice,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300
            });

            this.botDice.play("dice_blue_" + i);
        }

        AudioManager.playSound("dice_" + Math.ceil(Math.random() * 3));
    }

    public matchOver(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 300
        });
    }

    private onAnimationComplete(): void {

        if (GameVars.diceResult === 6) {

            AudioManager.playSound("six");

            let fx = this.scene.add.sprite(this.playerDice.x + 5, this.playerDice.y - 170, "texture_atlas_1", "victory_result_fx_07");
            fx.setScale(GameVars.scaleX * .3, .3);
            BoardScene.currentInstance.add.existing(fx);
            this.add(fx);
    
            fx.anims.play("victory_result");
    
            fx.on("animationcomplete", () => {
                fx.destroy();
            }, this);

            if (GameVars.currentTurn === GameConstants.BOT) {

                if (GameVars.mode === GameConstants.VS_PLAYER) {
                    fx.setPosition(this.botDice.x + 5, this.botDice.y - 170);
                } else {
                    fx.setPosition(this.botDice.x - 5, this.botDice.y + 170);
                }
            }
        }

        BoardManager.onDiceResultAvailable();
    }
}
